import { buffers } from 'redux-saga'
import { actionChannel, call, cancel, delay, fork, put, race, take } from 'redux-saga/effects'
import { refreshChatsCountAction, stopWatchChatsCountAction, watchChatsCountAction } from '../../handles'
import { fetchChatsCount } from './http/fetchChatsCount'
import { ChatsCountModel } from '@/models/chat.model'
import { FetchChatsCountSagaParams } from './types'

function* fetchChatsCountSaga({
  departmentId,
  campaignIds,
  ownerId,
  operatorId,
  chatFilters
}: FetchChatsCountSagaParams) {
  if (!campaignIds?.length || !departmentId || !ownerId) return
  const refreshChannel = yield actionChannel(refreshChatsCountAction, buffers.sliding(1))
  try {
    while (true) {
      try {
        const chatsCount: ChatsCountModel = yield call(fetchChatsCount, {
          departmentId,
          campaignIds,
          ownerId,
          operatorId,
          chatFilters,
          queryLimit: 5000
        })
        yield put(watchChatsCountAction.success(chatsCount))
      } catch (error) {
        yield put(watchChatsCountAction.failure(error))
      }
      // A buffered refresh cannot be lost while the HTTP request is in flight.
      yield race({ refresh: take(refreshChannel), timeout: delay(30000) })
    }
  } finally {
    refreshChannel.close()
  }
}

export function* watchChatsCountSaga(action: ReturnType<typeof watchChatsCountAction.request>) {
  const { departmentId, campaignIds, ownerId, operatorId, chatFilters } = action.payload

  const task = yield fork(fetchChatsCountSaga, { departmentId, campaignIds, ownerId, operatorId, chatFilters })

  yield take(stopWatchChatsCountAction().type)
  yield cancel(task)
}
